import "./monaco-setup.js";
import { mountApp } from "./mount-app.js";

mountApp();
